export default __webpack_public_path__ + "static/media/portfolio3.7bb40d02.png";